import * as actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import state from "./state";

export default {
  namespaced: true,
  state: { ...state },
  actions,
  mutations,
  getters
};
